import React, { useEffect } from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import FormField from '../../../forms/FormField';
const normalizePhone = require('../../../../utils/normalizePhone').handler;

const required = value => value ? undefined : 'Required';
const requiredNumber = value => !value && value !== 0 ? 'Required' : undefined;

const checkError = error => {
  const { jsonData } = error || {};
  const { json } = jsonData || {};
  const { message } = json || {};

  if (!message) return;

  switch (message) {
    case 'Address exists':
      return message;
    case 'Default Club':
      return message;
    default:
      return 'Generic';
  }
};

const EditAddressForm = (
  {
    handleSubmit,
    submitting,
    errorSubmit,
    editType,
    toggle,
    lookups,
    switchToWillCall,
    address,
    clearPutAddress,
    change,
    getAddressSuggestionsResult,
    handleSelect,
    searchAddress,
    searchValue,
    handleGetAddressSuggestions,
    Address1
  }
) => {

  useEffect(() => {
    if (Address1) {
      handleSelect({ searchAddress: false })
    }
    if (!Address1 || (Address1 || '').length < 2) {
      handleSelect({ searchAddress: true })
    }
  }, [Address1]);
  const {
    states
  } = lookups || {};
  const { IsClubAddress } = address || {};
  const stateOptions = (states || [])
    .filter(({ countryId }) => countryId === 37)
    .map(({ stateId, stateName }) => ({
      value: stateId,
      label: stateName
    }));

  const getStateId = (state) => {
    const stateObj = states.find(stateItem => stateItem.stateShort === state);
    return stateObj ? stateObj.stateId : null;;
  }
  const handleSelectSuggestedAddress = (e, value) => {
    const { city, street_line, secondary, state, zipcode } = value || {};
    handleSelect({ address1: street_line, searchAddress: false })
    change('Address1', street_line);
    change('Address2', secondary);
    change('City', city);
    change('StateID', getStateId(state));
    change('Zip', zipcode);
    change('StateShort', state);
    change('CountryId', 37);
  };



  const { suggestions } = getAddressSuggestionsResult || {};
  const suggestedOptions = (suggestions || []).map(a => ({
    value: a,
    label: a.secondary ? `${a.street_line} ${a.secondary}, ${a.city} ${a.state} ${a.zipcode} ` : `${a.street_line}, ${a.city} ${a.state} ${a.zipcode} `
  }))

  const handleBlur = () => {
    handleSelect({ searchAddress: false })
    change('Address1', searchValue);
  };

  const formSubmitError = checkError(errorSubmit);
  const willCallLocationOptions =
    [
      { value: 'Alexander Valley', label: 'Alexander Valley: 7300 Highway 128,  Healdsburg, CA 95448' },
      // { value: 'Calistoga', label: 'Calistoga: 1183 Dunaweal Lane, Calistoga, CA 94515' },
      { value: 'Healdsburg', label: 'Healdsburg: 3000 Westside Rd, Healdsburg, CA 95448' },
      { value: 'Oakville', label: 'Oakville: 915 Oakville Cross Rd, Oakville, CA 94562' },
      // { value: 'Twomey - Anderson Valley', label: 'Twomey - Anderson Valley: 4741 Highway 128, Philo, CA 95466-9571' },
      // { value: 'Twomey - Oregon', label: 'Twomey - Oregon: 19926 NE Fairview Dr, Dundee, OR 97115-9115' }
    ]
  return (
    <div className="col-products">
      <h1 className="smaller account-header">{editType} Address</h1>
      <h3 className="before-form">
        <a style={{ cursor: 'pointer' }} onClick={() => {
          clearPutAddress();
          toggle('address-book')
        }}>
          <i className="fas fa-chevron-left" /> Back To Address Book
        </a>
      </h3>
      <form onSubmit={handleSubmit}>
        {editType !== 'Add' && IsClubAddress &&
          < div className="row">
            <div className="col-md-12">
              <div className="d-flex align-items-center">
                <h5 style={{ marginBottom: '30px' }}>Switch to a pick up location:   </h5>
                <div style={{ marginLeft: '20px' }}>
                  <Field
                    name="switchToWillCall"
                    type="checkbox"
                    component={FormField.Switch}
                    onChange={() => clearPutAddress()}
                  />
                </div>
              </div>
            </div>
          </div>}
        {
          switchToWillCall &&
          <Field
            name="switchToWillCallLocation"
            type="text"
            component={FormField.SelectReact}
            placeholder="Select a pick up location"
            validate={[requiredNumber]}
            options={willCallLocationOptions}
          />
        }
        {
          !switchToWillCall &&
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <Field
                  name="Label"
                  type="text"
                  component={FormField.Input}
                  placeholder="Address Label"
                  validate={[required]}
                />
              </div>
              <div className="form-group">
                <Field
                  name="name_first"
                  type="text"
                  component={FormField.Input}
                  placeholder="First Name"
                  validate={[required]}
                />
              </div>
              <div className="form-group">
                <Field
                  name="name_last"
                  type="text"
                  component={FormField.Input}
                  placeholder="Last Name"
                  validate={[required]}
                />
              </div>
              <div className="form-group">
                <Field
                  name="Company"
                  type="text"
                  component={FormField.Input}
                  placeholder="Company"
                  validate={[]}
                />
              </div>
              <div className="form-row">
                <div className="col-6">
                  <Field
                    name="dobMonth"
                    type="text"
                    component={FormField.SelectReact}
                    placeholder="Birth Month"
                    validate={[requiredNumber]}
                    options={[
                      { value: 0, label: 'January' },
                      { value: 1, label: 'February' },
                      { value: 2, label: 'March' },
                      { value: 3, label: 'April' },
                      { value: 4, label: 'May' },
                      { value: 5, label: 'June' },
                      { value: 6, label: 'July' },
                      { value: 7, label: 'August' },
                      { value: 8, label: 'September' },
                      { value: 9, label: 'October' },
                      { value: 10, label: 'November' },
                      { value: 11, label: 'December' }
                    ]}
                  />
                </div>
                <div className="col-3">
                  <Field
                    name="dobDay"
                    type="text"
                    component={FormField.SelectReact}
                    placeholder="Day"
                    validate={[required]}
                    options={Array.from(Array(31), (_, i) => ({
                      value: i + 1,
                      label: i + 1
                    }))}
                  />
                </div>
                <div className="col-3">
                  <Field
                    name="dobYear"
                    type="text"
                    component={FormField.SelectReact}
                    placeholder="Year"
                    validate={[required]}
                    options={Array.from(Array(90), (_, i) => ({
                      value: new Date().getFullYear() - 21 - i,
                      label: new Date().getFullYear() - 21 - i
                    }))}
                  />
                </div>
              </div>
              <div className="form-group">
                <span className="form-disclaimer">
                  *Primary shipping/mailing, or club addresses cannot be removed
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-row">
                <div className="col-md-9">
                  <div className="form-group">

                    {!searchAddress &&
                      <Field
                        name="Address1"
                        component={FormField.Input}
                        type="text"
                        onChange={(e) => {
                          if (e.target.value.length < 3) {
                            handleSelect({ address1: '', searchAddress: true })
                          }
                        }}
                      />
                    }
                    {searchAddress &&
                      <Field
                        name="selectedFromAutoComplete"
                        type="text"
                        component={FormField.SelectReact}
                        onInputChange={(newValue) => {
                          handleGetAddressSuggestions(newValue);

                        }}
                        onBlur={(e, input) => handleBlur(e, input)}
                        options={suggestedOptions}
                        onChange={handleSelectSuggestedAddress}
                        placeholder='Enter Address'
                      />
                    }
                  </div>

                </div>
                <div className="col-md-3">
                  <div className="form-group ">
                    <Field
                      name="Address2"
                      type="text"
                      component={FormField.Input}
                      placeholder="Apt/Suite"
                      validate={[]}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <Field
                  name="City"
                  type="text"
                  component={FormField.Input}
                  placeholder="City"
                  validate={[required]}
                />
              </div>
              <div className="form-row">
                <div className="col-md-6">
                  <div className="form-group">
                    <Field
                      name="StateID"
                      type="text"
                      component={FormField.SelectReact}
                      placeholder="State"
                      validate={[required]}
                      options={stateOptions}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <Field
                      name="Zip"
                      type="text"
                      component={FormField.Input}
                      placeholder="Zip"
                      validate={[required]}
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12">
                  <Field
                    name="Phone"
                    type="text"
                    component={FormField.Input}
                    placeholder="Telephone"
                    validate={[required]}
                    normalizeOnBlur={normalizePhone()}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12">
                  <legend>Address Type:</legend>
                  <Field
                    required
                    name="isClubAddress"
                    type="checkbox"
                    component={FormField.InlineCheckbox}
                    label="Club Shipping Address"
                    normalize={value => !!value}
                  />
                  <Field
                    required
                    name="isDefaultShipping"
                    type="checkbox"
                    component={FormField.InlineCheckbox}
                    label="Primary Shipping Address"
                    normalize={value => !!value}
                  />
                  <Field
                    required
                    name="isDefaultMailing"
                    type="checkbox"
                    component={FormField.InlineCheckbox}
                    label="Primary Mailing Address"
                    normalize={value => !!value}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        <div className="form-row">
          <div className="col-md-3 form-group">
            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={submitting}
            >
              Save
            </button>
          </div>
          <div className="col-md-3">
            <button
              type="button"
              className="btn btn-inverse btn-block"
              onClick={() => {
                clearPutAddress()
                toggle('address-book')
              }}
              disabled={submitting}
            >
              Cancel
            </button>
          </div>
        </div>
        {formSubmitError === 'Address exists' &&
          <div className="form-row">
            <span style={{ color: '#dc3545', marginLeft: '10px' }}>
              This address already exists.
            </span>
          </div>}
        {formSubmitError === 'Default Club' &&
          <div className="form-row">
            <span style={{ color: '#dc3545', marginLeft: '10px' }}>
              Changing your default club address to a non-club address is restricted. To update your default club shipping address, simply create a new address or choose an existing one, then activate the 'Club Shipping Address' checkbox.
            </span>
          </div>}
        {formSubmitError === 'Generic' &&
          <div className="form-row">
            <span style={{ color: '#dc3545', marginLeft: '10px' }}>
              An error occured trying to add/edit this address.
            </span>
          </div>}
      </form>
    </div>
  );
};

const formName = 'edit-address-form';
const selector = formValueSelector(formName);

const mapState = state => {
  const switchToWillCall = selector(state, 'switchToWillCall')
  const Address1 = selector(state, 'Address1')
  return {
    switchToWillCall,
    Address1
  }
}

const form = reduxForm({ form: formName, enableReinitialize: true })(
  EditAddressForm
);
export default connect(mapState)(form);
